import { loader } from 'graphql.macro'

export default function dispatchPage ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./dispatchPage.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId: variables.haulerId,
    userId: variables.userId
  })
}
